import * as types from '../types.js';

export default {

	html: `
		<style>
			#stock_block_kind #company_id	{ width: 10rem; }
			#stock_block_kind #code		{ width: 12rem; }
			#stock_block_kind #label		{ width: 22rem; }
			#stock_block_kind #sort_order	{ width: 5rem; text-align: right; }
		</style>
		<form id="stock_block_kind" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<p class="fsxx" style="max-width:42rem">
				Códigos são fixos (seed). Aqui você <strong>renomeia o rótulo</strong> ou <strong>desativa</strong> a natureza para o tenant.
				Novos códigos exigem inclusão pelo SIAL (não quebram BI).
			</p>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Código interno (não editável)">Código
					<input id="code" type="text" disabled>
				</label>
				<label title="Rótulo exibido no bloqueio/desbloqueio">Rótulo<sup>*</sup>
					<input id="label" type="text" required maxlength="80">
				</label>
				<label title="Ordem na lista">Ordem
					<input id="sort_order" type="text">
				</label>
				<label title="Desativado some da lista operacional">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#stock_block_kind',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#code' }, types: [types.caps()] },
		{ properties: { selector: '#label' }, types: [] },
		{ properties: { selector: '#sort_order' }, types: [types.number(0, 0)] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]
};
